import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      return;
    }

    setStatus('loading');
    try {
      const formData = new FormData(form);
      formData.delete('phone_alt');

      const res = await fetch('https://readdy.ai/api/form/d9k75fohpes2mi34shlg', {
        method: 'POST',
        body: new URLSearchParams(formData as unknown as Record<string, string>),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });

      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      const serverMsg =
        (parsed && (parsed as Record<string, unknown>).meta && ((parsed as Record<string, unknown>).meta as Record<string, unknown>).message as string) ||
        (parsed && (parsed as Record<string, unknown>).message as string) ||
        '';

      if (res.ok && parsed && (parsed as Record<string, unknown>).code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        setStatus('error');
        setMessage(serverMsg || '订阅失败，请稍后再试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后再试。');
    }
  };

  const footerLinks = [
    {
      title: '热门类型',
      links: ['韩漫推荐', '日漫精选', '国漫专区', '恋爱漫画', '热血漫画', '奇幻漫画'],
    },
    {
      title: '快速链接',
      links: ['关于我们', '平台特色', '更新动态', '常见问题', '联系我们'],
    },
    {
      title: '合作伙伴',
      links: [],
    },
  ];

  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <span className="font-heading text-2xl text-primary-400 whitespace-nowrap">皮皮漫画</span>
            <p className="mt-4 text-sm text-background-300 leading-relaxed">
              皮皮漫画提供韩漫、日漫、国漫等多种类型漫画在线免费阅读平台，每日更新热门作品，为漫画爱好者打造一站式阅读体验。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-200 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-200 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-200 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-base text-background-50 mb-4">{group.title}</h4>
              {group.links.length > 0 ? (
                <ul className="space-y-2.5">
                  {group.links.map((link) => (
                    <li key={link}>
                      <a href="#" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-background-500">暂无合作伙伴展示</p>
              )}
            </div>
          ))}

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">订阅更新</h4>
            <form data-readdy-form="true" onSubmit={handleSubscribe} className="space-y-3">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入您的邮箱"
                required
                className="w-full px-4 py-2.5 rounded-lg bg-background-800 border border-background-700 text-background-100 text-sm placeholder:text-background-500 focus:outline-none focus:border-primary-500 transition-colors"
              />
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="antispam-field"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="w-full px-4 py-2.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
              >
                {status === 'loading' ? '提交中...' : '立即订阅'}
              </button>
              {status === 'success' && (
                <p className="text-xs text-accent-400">{message}</p>
              )}
              {status === 'error' && (
                <p className="text-xs text-primary-400">{message}</p>
              )}
            </form>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 皮皮漫画. 本站所有漫画均来自网络，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}